import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useDebouncedCallback } from 'use-debounce';
import { getEditorMarkdown } from '../utils';

const DEBOUNCE_DELAY = 5000;

export const DebouncedAutoSavePlugin = ({
  onSave,
}: {
  onSave: (markdown: string) => void | Promise<void>;
}) => {
  const [editor] = useLexicalComposerContext();

  const debouncedSave = useDebouncedCallback(
    (markdown: string) => void onSave(markdown),
    DEBOUNCE_DELAY,
  );

  useEffect(() => {
    const unregister = editor.registerUpdateListener(() => {
      const markdown = getEditorMarkdown(editor);

      if (markdown.length) {
        debouncedSave(markdown);
      }
    });

    return () => {
      unregister();
    };
  }, [editor, debouncedSave]);

  return null;
};
